// Telefonnummern einheitlich anzeigen (Design-Runde 2, L).
/** Eine Schreibweise für alle Telefonnummern (Design-Runde 2, L): international mit Leerzeichen, „+49 151 12345678“.
 *  Nimmt die Nummer und, wenn vorhanden, die von Close formatierte Fassung („0151 123-456“, „(07821) 12 34“). Ohne Länderkennung
 *  gilt Deutschland. Fehlt eine Gruppierung, wird nach Vorwahl und Rest geteilt (Mobilvorwahlen 15x/16x/17x). */
export function telefonText(nummer: string | null | undefined, formatiert?: string | null): string {
  const roh = ((formatiert && /\d{5}/.test(formatiert) ? formatiert : nummer) ?? "").trim();
  if (!roh) return "";
  let t = roh.replace(/\(0\)/g, "").replace(/[()\-/.]/g, " ").replace(/\s+/g, " ").trim();
  if (t.startsWith("00")) t = `+${t.slice(2)}`;
  else if (t.startsWith("0")) t = `+49 ${t.slice(1)}`;
  else if (!t.startsWith("+")) return roh;
  const teile = t.split(" ");
  if (teile.length >= 2 && /^\+\d{1,3}$/.test(teile[0])) return t; // schon gruppiert
  const ziffern = t.replace(/\s/g, "");
  const mobil = /^\+49(1[5-7]\d)(\d{6,9})$/.exec(ziffern);
  if (mobil) return `+49 ${mobil[1]} ${mobil[2]}`;
  const land = /^\+(420|421|49|43|41|31|33|34|39|44|48)(\d+)$/.exec(ziffern);
  return land ? `+${land[1]} ${land[2]}` : t;
}
